import { Row, Col } from 'src/componentes/grid';
import useAuth from 'src/hooks/useAuth';
import { useIntl } from 'react-intl';
import PeriodoData from 'src/paginas/data/periodo-data';
import ProjetoLookup from 'src/lookups/item';
import ContratoLookup from 'src/lookups/ContratoLookup';
import ConvenioLookup from 'src/lookups/ConvenioLookup';
import PlanoContasLookup from 'src/lookups/PlanoContasLookup';
import ConvenenteLookup from 'src/lookups/ConvenenteLookup';
import EntidadeLookup from 'src/lookups/MovimentacaoFinanceiraEntidadeLookup';

import { capitalizeFirstLetter } from 'src/utils/string';

const Search = ({ model }) => {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <ConvenioLookup
            model={{
              label: intl.formatMessage({ id: 'convenio' }),
              value: model.getModel('convenio').value,
              requestChange: model.getModel('convenio').requestChange,
            }}
          />
        </Col>
        <Col md={6}>
          <ContratoLookup
            model={{
              label: intl.formatMessage({ id: 'contrato' }),
              value: model.getModel('contrato').value,
              requestChange: model.getModel('contrato').requestChange,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <PlanoContasLookup
            model={{
              label: capitalizeFirstLetter(resources.planodecontas),
              value: model.getModel('planoContas').value,
              requestChange: model.getModel('planoContas').requestChange,
            }}
          />
        </Col>
        <Col md={6}>
          <ConvenenteLookup
            model={{
              label: intl.formatMessage({ id: 'convenente' }),
              value: model.getModel('convenente').value,
              requestChange: model.getModel('convenente').requestChange,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <EntidadeLookup
            model={{
              label: intl.formatMessage({ id: 'entidade' }),
              value: model.getModel('entidade').value,
              requestChange: model.getModel('entidade').requestChange,
            }}
          />
        </Col>
        <Col md={6}>
          <ProjetoLookup
            model={{
              label: <span>{capitalizeFirstLetter(resources.projeto)}</span>,
              value: model.getModel('projeto').value,
              requestChange: model.getModel('projeto').requestChange,
            }}
            data={{ tipoId: 4 }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <PeriodoData
            clearable={true}
            tipoFiltroData={model.getModel('tipoFiltroData').value}
            dataInicio={model.getModel('dataInicio').value}
            dataTermino={model.getModel('dataTermino').value}
            data={{ idsIgnorados: [7] }}
            onChange={handleChangeFiltro}
          />
        </Col>
      </Row>
    </>
  );
};

export default Search;
